import { Dialog, Grid } from '@material-ui/core';
import React from 'react';
import CloseButton from 'reusableComponents/CloseButton';
import { IRow } from '../models';
import InviteMenu from './InviteMenu';

interface IProps {
    rows: IRow[];
    setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function InviteMenuModal({ rows, setOpenMenu }: IProps) {
    return (
        <Dialog fullScreen open>
            <Grid container style={{ padding: 30 }}>
                <CloseButton onClose={() => setOpenMenu(false)} />
                <Grid container item style={{ paddingTop: 20 }}>
                    <InviteMenu rows={rows} />
                </Grid>
            </Grid>
        </Dialog>
    );
}
